import React from 'react';
import { Footer } from '../components/Footer';
import instagramIcon from '../assets/instagram-icon.svg';
import tiktokIcon from '../assets/tiktok-icon.svg';
import xIcon from '../assets/x-icon.svg';

interface MainLayoutProps {
  children: React.ReactNode;
}

export const MainLayout = ({ children }: MainLayoutProps) => {
  return (
    <div className="min-h-screen bg-white dark:bg-gray-900 flex flex-col transition-colors">
      <main className="flex-grow flex flex-col">
        {children}
      </main>
      
      {/* Social Icons - Centered above footer */}
      <div className="w-full flex justify-center gap-4 pb-8">
        <a href="#" className="w-5 h-5 text-black dark:text-white hover:opacity-70 transition-opacity cursor-pointer" aria-label="Instagram">
          <img src={instagramIcon} alt="Instagram" className="w-full h-full dark:brightness-0 dark:invert" />
        </a>
        <a href="#" className="w-5 h-5 text-black dark:text-white hover:opacity-70 transition-opacity cursor-pointer" aria-label="TikTok">
          <img src={tiktokIcon} alt="TikTok" className="w-full h-full dark:brightness-0 dark:invert" />
        </a>
        <a href="#" className="w-5 h-5 text-black dark:text-white hover:opacity-70 transition-opacity cursor-pointer" aria-label="X">
          <img src={xIcon} alt="X" className="w-full h-full dark:brightness-0 dark:invert" />
        </a>
      </div>

      <Footer />
    </div>
  );
};
